import type { CtxProductVariant } from '@containex/portal-backend-api-client';
import { DepotType, ProductType } from '@containex/portal-backend-dto';
import { VIRTUAL_DEPOT } from '@containex/portal-business-logic';

export function filterProductVariantForProvisionType(
    variant: CtxProductVariant,
    countryCode: string | undefined,
    isRental: boolean,
    productType: ProductType | undefined | null = ProductType.CONTAINER_PRODUCT
): boolean {
    if (isRental) {
        return variant.depotQuantity.depot.type === DepotType.Rental;
    }

    // variants for serial number products are not filtered out, if it's not a similar product
    if (productType === ProductType.SERIAL_NUMBER_PRODUCT) {
        return true;
    }

    return (
        variant.depotQuantity.depot.type === DepotType.ProductionSite ||
        variant.depotQuantity.depot.address.country_code?.toLowerCase() === countryCode?.toLowerCase()
    );
}

export function filterProductVariantForAvailableNowTypes(
    variant: CtxProductVariant,
    availableExFactory: boolean,
    availableExDepot: boolean
): boolean {
    return variant.depotQuantity.depot.depot_id === VIRTUAL_DEPOT ? availableExFactory : availableExDepot;
}
